import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetChildrenByStatusQuery } from '@/services/child-api';
import Page from '@/components/page';
import PageTitle from '@/components/page-title';
import QuickViewResults from './quick-view-results';
import { useGetCodeChildStatusQuery } from '@/services/general-api';

const ChildQuickViewPage = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const statusKey = queryParams.get('status');
  const statusReasonId = queryParams.get('statusReasonId');
  const baseReportType = queryParams.get('reportType');
  const adoptionLiaisonId = queryParams.get('liaison');
  const pageNumber = queryParams.get('page') || 1;
  const [title, setTitle] = useState('');
  const [breadcrumb, setBreadcrumb] = useState();

  const reportType = statusReasonId ? statusReasonId : baseReportType;

  const { data, isFetching } = useGetChildrenByStatusQuery(
    { statusKey, pageNumber, pageSize: 10, reportType, adoptionLiaisonId },
    { skip: !statusKey },
  );
  const { data: codeChildStatus, isFetching: isLoading1 } = useGetCodeChildStatusQuery(
    { statusKey },
    { skip: !statusKey },
  );

  const [results, setResults] = useState();

  useEffect(() => {
    if (!statusKey) setResults();
  }, [statusKey]);

  useEffect(() => {
    if (codeChildStatus) {
      setTitle(codeChildStatus.name + ' Children');
      setBreadcrumb([
        { path: '/child', label: 'Children' },
        { path: '/child/quick-view', label: 'Quick View' },
        codeChildStatus.name,
      ]);
    }
  }, [codeChildStatus]);

  useEffect(() => {
    setResults(data);
  }, [data]);

  return (
    <Page breadcrumb={breadcrumb} size="xl">
      <PageTitle label="Children Quick View" />
      <QuickViewResults
        status={statusKey}
        reportType={reportType}
        data={results}
        title={title}
        loading={isFetching || isLoading1}
      />
    </Page>
  );
};

export default ChildQuickViewPage;
